import { decode } from 'jwt-js-decode'
import moment from 'moment'

import AuthMixin from '@/components/mixins/auth-mixin'

const jwt = {
  decode
}

export default {
  name: 'defaultLayoutStructurePage',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
  },
  props: {
    dataProp: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      activeNames: [],
      dataPropVal: this.dataProp,
      expand: false,
      getPlan: null,
      userSession: {
        JWToken: this.$currentUser.getJWToken() ? this.$currentUser.getJWToken() : null,
        JWTokenDecode: this.$currentUser.getJWToken() ? jwt.decode(this.$currentUser.getJWToken())?.payload : null,
        expire: this.$currentUser.getJWToken() ? moment(new Date(jwt.decode(this.$currentUser.getJWToken())?.payload?.exp * 1000)).format('YYYY-MMM-DD HH:mm:ss') : null
      }
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('default-layout-change', { action, payload: { data } })
      }
    },
    handleChange (val) {
      if (Array.isArray(val) && val.indexOf('1') >= 0 && this.getPlan === null) {
        this.$currentUser.getUserInfoFromBackend({
          callback: (usersInfo) => {
            this.getPlan = usersInfo
            this.$utils.mainLoader(false)
          }
        })
      }
    },
    handleDebugExpand () {
      if (this.expand) {
        this.expand = false
      } else {
        this.expand = true
      }
    },
    async performRevokeRefreshToken () {
      this.$utils.mainLoader(true)
      this.postRevokeRefreshTokenFromLegacySession({
        callback: (response) => {
          this.$utils.mainLoader(false)
          console.log('Revoke refresh token native login', response)
        }
      })
    }
  },
  mounted () {}
}
